import { CombinedActionTypes } from './actionsFactory';
import archivedBookingsReducer, {
  State as ArchivedBookingsState,
  initState as archivedBookingsInitState,
} from './bookings/archivedBookingsReducer';
import bookingsReducer, {
  State as BookingsState,
  initState as bookingsInitState,
} from './bookings/bookingsReducer';
import upcomingBookingsReducer, {
  State as UpcomingBookingsState,
  initState as upcomingBookingsInitState,
} from './bookings/upcomingBookingsReducer';
import actionsRequiredReducer, {
  State as ActionsRequiredState,
  initState as actionsRequiredInitState,
} from './chat/actionsRequiredReducer';
import chatContactsReducer, {
  State as ChatContactsState,
  initState as chatContactsInitState,
} from './chat/chatContactsReducer';
import contactsReducer, {
  State as ContactsState,
  initState as contactsInitState,
} from './chat/contactsReducer';
import messagesReducer, {
  State as MessagesState,
  initState as messagesInitState,
} from './chat/messagesReducer';

export interface State {
  upcomingBookings: UpcomingBookingsState;
  archivedBookings: ArchivedBookingsState;
  contacts: ContactsState;
  chatContacts: ChatContactsState;
  messages: MessagesState;
  actionsRequired: ActionsRequiredState;
  bookings: BookingsState;
}

export const initState = {
  upcomingBookings: upcomingBookingsInitState,
  archivedBookings: archivedBookingsInitState,
  contacts: contactsInitState,
  chatContacts: chatContactsInitState,
  messages: messagesInitState,
  actionsRequired: actionsRequiredInitState,
  bookings: bookingsInitState,
};

export default (state: State, action: CombinedActionTypes): State => {
  return {
    upcomingBookings: upcomingBookingsReducer(state.upcomingBookings, action),
    archivedBookings: archivedBookingsReducer(state.archivedBookings, action),
    contacts: contactsReducer(state.contacts, action),
    chatContacts: chatContactsReducer(state.chatContacts, action),
    messages: messagesReducer(state.messages, action),
    actionsRequired: actionsRequiredReducer(state.actionsRequired, action),
    bookings: bookingsReducer(state.bookings, action),
  };
};
